import { Middleware } from "redux";
import { REMOVE_AUTH_USER } from "../../redux/auth/authSlice";
import { loginRequest, msalConfig } from "../../authConfig";
import { PublicClientApplication } from "@azure/msal-browser";

let pca: PublicClientApplication | null = null;
const initializePca = async () => {
  pca = new PublicClientApplication(msalConfig);
  await pca.initialize();
};
initializePca().catch((error) => {
  console.error("Error in pca", error);
});
const tokenExpirationMiddleware: Middleware = (store) => (next) => async (action: any) => {
  // Avoid running the middleware for the logout action
  if (action.type !== "auth/REMOVE_AUTH_USER") {
    const state = store.getState();
    const { accessToken, expiresOn } = state.auth.auth;
    if (accessToken) {
      const currentTime = new Date().getTime();
      console.log("currentTime = ", currentTime);
      console.log("expiresOn = ", expiresOn);
      if (currentTime > expiresOn) {
        store.dispatch(REMOVE_AUTH_USER());
        try {
          await pca?.loginRedirect(loginRequest);
        } catch (error) {
          console.log("error in redirect", error);
        }
      }
    }
  }

  return next(action);
};

export default tokenExpirationMiddleware;
